import { render, staticRenderFns } from "./ViewClientActivities.vue?vue&type=template&id=5b59be28"
import script from "./ViewClientActivities.vue?vue&type=script&lang=js"
export * from "./ViewClientActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports